export default __webpack_public_path__ + "static/media/table-lock.a0c8f3b0.svg";